import { observer } from 'mobx-react-lite'
import {
  Navigate,
  useLoaderData,
  useOutletContext,
  useParams,
} from 'react-router'
import type { TeamsViewModel } from '@/features/iam/teams/TeamsViewModel'
import type { TeamViewLoaderData } from '@/features/iam/iam-route-loaders'
import { links } from '@/utils/link'
import { TeamContainer } from '@/features/iam/teams/components/Team/TeamContainer'

/**
 * Shows the team the route names.
 */
export default observer(function WorkspaceTeamContainer() {
  const data = useLoaderData<TeamViewLoaderData>()
  const teamsVm = useOutletContext<TeamsViewModel>()
  const { teamSlug = '' } = useParams<{ teamSlug: string }>()
  if (!data) {
    return null
  }

  // Renaming or leaving the team takes it away from the route's slug.
  return teamsVm.findTeam(teamSlug) === data.vm.team ? (
    <TeamContainer key={data.vm.team.id} vm={data.vm} />
  ) : (
    <Navigate replace to={links.team()} />
  )
})
